import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PolymerModule } from '@codebakery/origami';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { FslModule } from './fsl/fsl.module';
import { CoreModule } from './core/core.module';
import { FslGuard } from './fsl/guards/fsl-guard';
import { AppInitializerService } from './fsl/services/shared/app-initializer.service';
import { DeactivateGuardService } from './fsl/guards/deactivate-guard';

export function appInitializerServiceFactory(appInitializerService: AppInitializerService) {
  return () => {
    return appInitializerService.setSessionValuesFromQueryString();
  };
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    FslModule,
    BrowserModule,
    HttpClientModule,
    FormsModule, // Origami requires the Angular Forms module
    PolymerModule.forRoot(), // Do not call .forRoot() when importing in child modules
    ReactiveFormsModule,
    CoreModule
  ],
  providers: [
    FslGuard,
    AppInitializerService,
    DeactivateGuardService,
    {
      'provide': APP_INITIALIZER,
      'useFactory': appInitializerServiceFactory,
      'deps': [AppInitializerService],
      'multi': true,
  },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
